// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-file-GMtbt5{cursor:pointer;background-position:50%;background-repeat:no-repeat;background-size:cover;border:1px solid rgba(10,17,61,.06);border-radius:8px;width:60px;height:60px;position:relative}.mask-FN5rej{color:#fff;background-color:rgba(0,0,0,.48);border-radius:8px;justify-content:center;align-items:center;width:100%;height:100%;display:flex;position:absolute;top:0;left:0}.mask-FN5rej .icon-refresh-_nzhQr{cursor:pointer}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image-file": `image-file-GMtbt5`,
	"imageFile": `image-file-GMtbt5`,
	"mask": `mask-FN5rej`,
	"icon-refresh": `icon-refresh-_nzhQr`,
	"iconRefresh": `icon-refresh-_nzhQr`
};
export default ___CSS_LOADER_EXPORT___;
